/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from '../'

export class ExpandableSelection extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    expand: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    expand: false,
    className: ''
  }

  constructor(props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  handleClick = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }))
  }

  render() {
    let displayStyle = this.state.expanded ? 'block' : 'none'

    return (
      <div className={`slds-section ${this.state.expanded ? 'slds-is-open' : ''} ${this.props.className}`}>
        <h3>
          <Button
            type='reset'
            className='expandable-selection-button'
            onClick={this.handleClick}>
            <div className='slds-grid slds-size_1-of-1'>
              {this.props.title}
              <div className='slds-col_bump-left'>
                <SvgIcon
                  variant='utility'
                  symbol={this.state.expanded ? 'chevronup' : 'chevrondown'}
                  size='x-small'
                />
              </div>
            </div>
          </Button>
        </h3>
        <div
          className='slds-section__content slds-m-left_x-small'
          style={{ display: displayStyle }}>
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/expandable-selection/index.js